import { Spinner } from 'react-bootstrap';

/**
 * Индикатор загрузки для форм
 */
export const FormLoading = () => {
  return (
    <div className="d-flex justify-content-center align-items-center bg-white p-4 rounded-3 shadow-sm" style={{ minHeight: '400px' }}>
      <Spinner animation="border" variant="primary" />
    </div>
  );
};
